import React, {lazy, Suspense} from 'react';
import Modal from '../../Components/Modal';
import { googleMapsAPI, preload } from '../../Services/helpers';
import { PageLoading } from '../../Components/Loading';
const ThePatchMap  = lazy(() => import(/* webpackChunkName: "maps" */'./ThePatchMap'));

const MyPatch = ({isOpen, onClose, onSave}) => {

    preload(googleMapsAPI);

    return <Modal isOpen={isOpen} setIsOpen={onClose} title="My Patch" dismissible>

        <p className="text-sm text-muted my-2">
            Move the markers to highlight the area where you provide services.
        </p>

        {isOpen && <Suspense fallback={<PageLoading />}>
            <ThePatchMap onSave={onSave} onClose={onClose} />
        </Suspense>}
    </Modal>
}

export default MyPatch;
